import CamposPersonaParientes from "../campos/CamposPersonaParientes.js";
import TablaPersonaParientes from "../tablas/TablaPersonaParientes.js";
import * as Campos from "../../constantes/Campos.js";
import { NombreCompleto } from "../../funciones/FuncionesPersona.js";

// Funciones para CuadroEditableLista

export const armarFilasTabla = (lista, idElegido, onEditarItem, onEliminarItem) => {
  return (
    <TablaPersonaParientes
      lista={lista}
      idElegido={idElegido}
      onEditarItem={onEditarItem}
      onEliminarItem={onEliminarItem}
    />
  );
}

export const OrdenarLista = (itemA, itemB) => {
  const ordenA = itemA.pariente && NombreCompleto(itemA.pariente);
  const ordenB = itemB.pariente && NombreCompleto(itemB.pariente);
  return ordenA - ordenB;
}

// Funciones para EditarItemLista

export const CamposEdicion = (idPadre, item, editar, actualizar, onCampoChange) => {
  return (
    <CamposPersonaParientes
      idPadre={idPadre}
      item={item}
      editar={editar}
      actualizar={actualizar}
      onCampoChange={onCampoChange}
    />
  );
}

export const OnCampoChange = (item, campo, valor) => {
  switch (campo) {
    case Campos.Parentesco.TIPO_PARENTESCO:
      return { ...item, tipoParentesco: valor };
    case Campos.Parentesco.PARIENTE:
      return { ...item, pariente: valor };
    default:
      throw new Error("Campo "+campo+ " no definido");
  }
};

export const ValidarItemGrabar = (item) => {
  let error = "";
  if (!item) {
    error = "No se informaron datos para el parentesco de la persona";
  } else if (!item.pariente) {
    error = "Debe seleccionar al pariente de la persona";
  } else if (!item.tipoParentesco) {
    error = "Debe seleccionar el tipo de parentesco de la persona";
  }
  return error;
}
